import { axiosNT } from '../../../services/axios';

const getVideoSignedUrl = (contentType: string = "", id?: any) => {
	let url = `aws?contentType=${contentType}`;
    if (id) url+= `&id=${id}`;
	return axiosNT
	.get(url)
	.then((res: any) =>{
		return Promise.resolve(res);
})};

const getYouTubeVideoUrl = (contentType: any, url:any, id?: any) => {
	let endpoint = `video/url?contentType=${contentType}&url=${url}`;
    if (id) endpoint+= `&id=${id}`;
	return axiosNT
	.get(endpoint)
	.then((res: any) =>{
		return Promise.resolve(res);
})};

const deleteVideoFromS3 = (typeKey: any, key:any) => axiosNT
	.delete(`video/?${typeKey}=${key}`)
	.then((res: any) =>{
		return Promise.resolve(res);
});

const deleteAudioFromS3 = (typeKey: any, key:any) => axiosNT
	.delete(`audio/?${typeKey}=${key}`)
	.then((res: any) =>{
		return Promise.resolve(res);
});

const getHlsUrl = async (key: any) => {
    return await axiosNT.get(`video/hls?key=${key}`)
        .then((res: any) => {
            const { video }: { video: any } = res.responseObject || {};
            return Promise.resolve(video);
        }).catch((error) => {
            return Promise.reject(error);
        })
}

export default {
	getVideoSignedUrl,
	getYouTubeVideoUrl,
	deleteVideoFromS3,
	deleteAudioFromS3,
	getHlsUrl,
};